/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_REGISTER_GST_STATE,
  CLOSE_BSB_NOTICE,
  RESET_TUGO_BANK_FIELDS,
  RESET_ADDRESS,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormRegisterGstState() {
  return {
    type: RESET_REGISTER_GST_STATE,
  };
}

export function closeBSBNotice() {
  return {
    type: CLOSE_BSB_NOTICE,
  };
}

export function resetTugoBankFields() {
  return {
    type: RESET_TUGO_BANK_FIELDS,
  };
}

export function resetFormDataAddress() {
  return {
    type: RESET_ADDRESS,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/actions.js